module.exports = __webpack_public_path__ + "img/selected0-min.dee62195.png";